import axios from 'axios';

export function createConfig() {
  const config = {};
  config.redirectUri = `${window.location.origin}/auth-redirect`;

  switch (window.location.origin) {
    case 'https://va-a.maven.liveperson.net':
    case 'https://z1-a.maven.liveperson.net':
    case 'https://mavenhub.alpha.int.gw.lpcloud.io':
    case 'https://va-a-lp.maven.liveperson.net':
    case 'https://staging.mavenhub.liveperson.net':
      config.clientId = 'aa65bf00-b2b3-4c48-9ecb-d88cc13a9930';
      break;
    case 'https://va.maven.liveperson.net':
    case 'https://z1.maven.liveperson.net':
      config.clientId = '67c6477a-e474-4be4-90ac-0273ea9ef945';
      break;
    case 'https://lo.maven.liveperson.net':
    case 'https://z2.maven.liveperson.net':
      config.clientId = '67c6477a-e474-4be4-90ac-0273ea9ef945';
      break;
    case 'https://sy.maven.liveperson.net':
    case 'https://z3.maven.liveperson.net':
    case 'https://ause1.mavenhub.liveperson.net':
    case 'https://mavenhub.au.prod.int.gw.lpcloud.io':
      config.clientId = '67c6477a-e474-4be4-90ac-0273ea9ef945';
      break;
    case 'https://lp-mavenhub-qa.dev.lprnd.net':
    case 'https://mavenhub.qa.int.gw.lpcloud.io':
      config.clientId = 'd8d1c9d6-e85a-425e-8c6a-d90b20f4fa77';
      break;
    default:
      config.clientId = 'd8d1c9d6-e85a-425e-8c6a-d90b20f4fa77';
      break;
  }

  return config;
}

export const authConfig = createConfig();

export function createAuthState({ accountId, path }) {
  return `${accountId},${path.split('/')
    .join('_')}`;
}

export function parseAuthState(state) {
  // Use , to parse out the accountId and pathFrom from state.
  // Change _ back to / since SSO API rejects /.
  const [accountId, rawPath] = state.split(',');
  const path = rawPath.split('_')
    .join('/');

  return {
    accountId,
    path,
  };
}

export default class Auth {
  constructor({ baseURL }) {
    this.baseURL = baseURL;
  }

  async login(accountId, code, redirectUri, clientId) {
    const result = await axios.post(`${this.baseURL}/v2/account/${accountId}/login`, {
      code,
      redirectUri,
      clientId,
    });

    return result.data;
  }

  async verify(accountId) {
    const result = await axios.post(`${this.baseURL}/v2/account/${accountId}/verify-bearer`);
    return result.data;
  }

  async logout(accountId) {
    const result = await axios.post(`${this.baseURL}/v2/account/${accountId}/logout`);
    return result.data;
  }

  async getSentinelBaseUrl(accountId) {
    const result = await axios.get(`${this.baseURL}/v2/account/${accountId}/sentinel`);
    return result.data;
  }
}
